import { datadogRum } from "@datadog/browser-rum";

export default {
  init: (options) => {
    datadogRum.init(options);
  },
  start: () => {
    datadogRum.startSessionReplayRecording();
  },
  addAction: (name, obj) => {
    datadogRum.addAction(name, obj);
  },
};
